import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';

export default function Loader({ ...props }) {
  return (
    <View style={styles.orContainer}>
      {(props.lines === undefined || props.lines) &&
        <View style={styles.horizontalLine}></View>
      }
      <Text style={[CS.smallText, CS.lightBlueText, styles.or]}>or</Text>
      {(props.lines === undefined || props.lines) &&
        <View style={styles.horizontalLine}></View>
      }
    </View>
  )
}

const styles = StyleSheet.create({
  orContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    // marginTop: 10,
    // marginBottom: 20,
    marginVertical: 5,
  },
  or: {
    textAlign: 'center',
    marginHorizontal: 10,
    flex: 1,
  },
  horizontalLine: {
    height: 1,
    flex: 5,
    backgroundColor: Colors.lightBlue2,
  }
})